import { PropertyType as PropertyTypeEnum } from '@/entities/room'

import { PROPERTY_TYPES } from './option'
import { FilterType } from '../../../model/filter'
import { Title, List, Item } from '../../common/layout'

type Props = {
  type: FilterType
  ref: (element: HTMLDivElement) => void
  className?: string
  selected: (value: PropertyTypeEnum) => boolean
  onChange: (value: PropertyTypeEnum) => void
}

export const PropertyTypesInDefaultView = ({
  type,
  ref,
  className,
  selected,
  onChange,
}: Props) => {
  const handlePropertyTypeChange = (value: PropertyTypeEnum) => () => {
    onChange(value)
  }

  return (
    <div className={className} ref={ref}>
      <Title>건물 유형</Title>
      <List>
        {PROPERTY_TYPES.map(({ title, value }) => (
          <Item
            key={title}
            type={type}
            selected={selected(value)}
            onClick={handlePropertyTypeChange(value)}
            className="whitespace-nowrap"
          >
            <p className="flex h-11 items-center justify-center">
              {title.replace(/\n/g, '')}
            </p>
          </Item>
        ))}
      </List>
    </div>
  )
}
